var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDividerVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 16,
    viewBox: "0 0 1 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Divider (Vertical)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Divider Line",
    width: 1,
    height: 16,
    fill: "#DFE2E7"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDividerVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/divider_vertical.391884ef156f7ebd2b2669fb49af30ae.svg";